import React from 'react';
import BlockLayouts from './BlockLayouts/BlockLayouts';
import ElementsCollection from './ElementsCollection/ElementsCollection';
import QuickBlocks from './QuickBlocks/QuickBlocks';
import HorizontalRule from '../../componentLibrary/HorizontalRule';

export default () => (
    <div>
        <div style={{ width: 180, margin: '0 auto', height: 144, paddingTop: 12 }}>
            <div style={{ position: 'relative' }}>
                <h2
                    style={{
                        display: 'inline-block',
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: 1,
                        color: '#535454',
                    }}
                >
                    BLOCK LAYOUTS
                </h2>
            </div>
            <BlockLayouts />
        </div>
        <HorizontalRule styling={{ width: 180, position: 'relative', left: 35, marginBottom: 0 }} />
        <div style={{ width: 180, margin: '0 auto', height: 132, padding: '12px 0px 0px' }}>
            <div style={{ position: 'relative' }}>
                <h2
                    style={{
                        display: 'inline-block',
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: 1,
                        color: '#535454',
                    }}
                >
                    ELEMENTS
                </h2>
            </div>
            <ElementsCollection />
        </div>
        <HorizontalRule styling={{ width: 180, position: 'relative', left: 35, marginBottom: 0, marginTop: 5 }} />
        <div
            className="scrollFix"
            style={{
                width: 180,
                left: 'calc(50% - 90px)',
                position: 'absolute',
                overflowY: 'hidden',
                paddingTop: 12,
                height: 'calc(100% - 306px)',
            }}
        >
            <div style={{ position: 'relative' }}>
                <h2
                    style={{
                        display: 'inline-block',
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: 1,
                        color: '#535454',
                    }}
                >
                    QUICK BLOCKS
                </h2>
            </div>
            <QuickBlocks />
        </div>
    </div>
);
